import type { SVGProps } from 'react';
const SvgInsertDriveFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#insert_drive_file_svg__a)">
      <path
        fill="currentColor"
        d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6Zm7 7V3.5L18.5 9H13Z"
      />
    </g>
    <defs>
      <clipPath id="insert_drive_file_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInsertDriveFile;
